import PropTypes from 'prop-types';
import { Portal } from 'react-portal';
import React from 'react';

import Icon, { GLYPHS } from '../../common/icon';
import squireLogo from '../../../../images/logo.svg';
import withBoundingClientRect from '../../common/hoc/withBoundingClientRect';

const VERTICAL_OFFSET = -31;
const HORIZONTAL_OFFSET = +60;

const NavExplainer = ({ boundingClientRect, close, title, description }) => (
  <Portal>
    <div>
      <div className="c-overlay c-overlay--fadein" onClick={close} />
      <div
        className="c-explainer-tooltip-wrapper"
        style={{
          top: boundingClientRect.top + VERTICAL_OFFSET,
          left: boundingClientRect.left + HORIZONTAL_OFFSET,
        }}
        display-if={boundingClientRect.top && boundingClientRect.right > 0}
      >
        <div className="c-explainer-tooltip">
          <div className="c-explainer-tooltip__controls">
            <button className="c-btn c-btn--blank" type="button" onClick={close}>
              <Icon glyph={GLYPHS.closeBtn} size="micro" />
            </button>
          </div>
          <img src={squireLogo} alt="Squire" width="36" />
          <h2 className="c-explainer-tooltip__title">{title}</h2>
          <p>
            {description}
          </p>
          <button
            type="button"
            onClick={close}
            className="c-link-button"
          >
            Dismiss
          </button>
        </div>
      </div>
    </div>
  </Portal>
);

NavExplainer.propTypes = {
  boundingClientRect: PropTypes.object.isRequired,
  close: PropTypes.func,
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

NavExplainer.defaultProps = {
  close: () => null,
};

export default withBoundingClientRect(NavExplainer);
